module.exports = __webpack_public_path__ + "static/media/vu-active.b425e8e1.png";